export default __webpack_public_path__ + "static/media/AskMeLogoAlt.0d52a756.jp2";